module.exports = __webpack_public_path__ + "static/media/domnic-brown.6c65f167.png";